/* eslint-disable @typescript-eslint/no-explicit-any */
export default class {
  static isProductForVehicle(product: any, vehicle: any): boolean {
    return product.subscriptionLevel__c == vehicle.ownerRelation
  }

  static isThirdPartyVehicle(vehicle: any): boolean {
    return (
      vehicle.ownerRelation != 'Truck' && vehicle.ownerRelation != 'Company'
    )
  }
  static hasAccountRelations(accountRelations: any) {
    return Object.keys(accountRelations).some(
      key => key && !key.toString().match(/owner/i)
    )
  }

  static hasRelationForService(service: any, accountRelations: any) {
    const hasNoRelations =
      Object.keys(accountRelations).length == 0 &&
      (service.subscriptionLevel__c == 'Truck' ||
        service.subscriptionLevel__c == 'Company')

    const hasMatchingRelation = Object.keys(accountRelations).some(
      key =>
        key == service.subscriptionLevel__c ||
        (key.toString().match(/owner/i) &&
          (service.subscriptionLevel__c == 'Truck' ||
            service.subscriptionLevel__c == 'Company'))
    )

    return hasNoRelations || hasMatchingRelation
  }

  static hasOnlyThirdPartyVehicles(trucks: any[]): boolean {
    return (
      trucks.length > 0 &&
      trucks.every(
        (truck: any) =>
          truck.ownerRelation != 'Truck' && truck.ownerRelation != 'Company'
      )
    )
  }

  static hasOwnerRelation(accountRelations: any) {
    const keys = Object.keys(accountRelations)

    return keys.length == 0 || keys.some(key => key.toString().match(/owner/i))
  }
}
